import api from 'ApiConfig';

const batchStructureService = {
  createBatchStructure: async (data) =>
    api.post('/admin/create-batch-structure', data),

  getAllBatchStructures: async () => api.get('/admin/get-all-batch-structures'),

  getBatchStructureById: async (id) =>
    api.get(`/admin/get-batch-structure/${id}`),

  updateBatchStructure: async (id, data) =>
    api.post(`/admin/update-batch-structure/${id}`, data),

  deleteBatchStructure: async (id) =>
    api.delete(`/admin/delete-batch-structure/${id}`),

  getBatchStructuresByCourse: async (courseId) =>
    api.post(`/admin/get-batch-structures-by-course/${courseId}`),

  getBatchesByBatchStructure: (structureId, selectedBranch) =>
    api.post('/admin/get-batches-by-structure', {
      batchStructureId: structureId,
      selectedBranch,
    }),
};

export default batchStructureService;
